import { useTranslation } from 'react-i18next';
import { useGet } from '@/query/fetchHooks';
import { format } from 'date-fns';
import { DataTable } from '@/components/DataTable/DataTable';
import { Button, ButtonLink, Tag } from '@teo/components';
import { config } from '@/config';

function HelpDeskTab({ auth }: any) {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');

  const downloadLink = `${config.backend}/analytics/supportevents/csv/${auth?.user?.activeOrganisationId}`;

  return (
    <div className="">
      <div className="flex pt-8 pb-6">
        <p className="text-md font-semibold text-black">
          {t('pages.organisation_licensing_and_billing.help_desk_tab')}
        </p>
        <div className="ml-auto flex">
          <ButtonLink
            to={downloadLink}
            size="sm"
            variant="outline"
            download
            className="border-grey-o3 border"
            data-testid="downloadOverview"
          >
            {t('pages.organisation_licensing_and_billing.table.download')}
          </ButtonLink>
        </div>
      </div>
      <DataTable
        fetch={useGet.bind(null, '/supportevents', {
          organisationId: auth?.user?.activeOrganisationId,
        })}
        defaultSort={[
          { id: '-endTime', desc: false },
          { id: '-id', desc: false },
        ]}
        columns={[
          {
            addTitleOnMobile: true,
            title: t(
              'pages.organisation_licensing_and_billing.table.ticket_id'
            ),
            id: 'ticketID',
            sortable: false,
            className: 'col-start-1 col-end-4 row-start-2',
            render: (row: any) => row.ticketId,
          },
          {
            addTitleOnMobile: true,
            title: t('pages.organisation_licensing_and_billing.table.start'),
            id: '-id',
            className: 'col-start-1 col-end-5 row-start-1',
            render: (row: any) => format(new Date(row.startTime), 'dd/MM/yyyy'),
          },
          {
            addTitleOnMobile: true,
            id: '-endTime',
            title: t('pages.organisation_licensing_and_billing.table.end'),
            className:
              'col-start-5 col-end-10 row-start-1 justify-end text-right',
            render: (row: any) => format(new Date(row.endTime), 'dd/MM/yyyy'),
          },
          {
            addTitleOnMobile: true,
            id: 'type',
            title: t('pages.organisation_licensing_and_billing.table.type'),
            sortable: false,
            className:
              'col-start-4 col-end-7 row-start-2 justify-center text-center',
            render: (row: any) => row.type,
          },
          {
            addTitleOnMobile: true,
            id: 'description',
            title: t(
              'pages.organisation_licensing_and_billing.table.description'
            ),
            sortable: false,
            className: 'col-start-1 col-end-10 row-start-3',
            render: (row: any) => row.description,
          },

          {
            addTitleOnMobile: true,
            id: 'credits',
            title: t('pages.organisation_licensing_and_billing.table.credits'),
            sortable: false,
            className:
              'col-start-7 col-end-10 row-start-2 justify-end text-right',
            render: (row: any) => row.credits,
          },
          {
            addTitleOnMobile: true,
            id: 'status',
            title: t('columns.status'),
            sortable: false,
            className:
              'col-start-7 col-end-10 row-start-2 justify-end text-right',
            render: (row: any) => (
              <div className="flex min-w-max items-center ">
                {row?.status == 2 ? (
                  <Tag
                    variant="success"
                    size="sm"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.open'
                    )}
                  ></Tag>
                ) : row?.status == 3 ? (
                  <Tag
                    variant="secondary"
                    size="sm"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.pending'
                    )}
                  ></Tag>
                ) : row?.status == 4 ? (
                  <Tag
                    size="sm"
                    variant="error"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.resolved'
                    )}
                  ></Tag>
                ) : row?.status == 5 ? (
                  <Tag
                    size="sm"
                    variant="error"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.closed'
                    )}
                  ></Tag>
                ) : row?.status == 6 ? (
                  <Tag
                    variant="primary"
                    size="sm"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.waiting_customer'
                    )}
                  ></Tag>
                ) : row?.status == 7 ? (
                  <Tag
                    variant="primary"
                    size="sm"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.waiting_external'
                    )}
                  ></Tag>
                ) : (
                  <Tag
                    size="sm"
                    title={t(
                      'pages.organisation_licensing_and_billing.table.no_status'
                    )}
                  ></Tag>
                )}
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}

export default HelpDeskTab;
